import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { IDashboardResult } from './idashboard';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private _httpClient: HttpClient) { }

  getDashboard(): Observable<BaseRespone<IDashboardResult>> {
    return this._httpClient.get<BaseRespone<IDashboardResult>>(
      `${environment.baseURl}/Dashboard`
    );
  }
}
